<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="nav-item has-sub"
    :class="{
      open: isOpen,
      disabled: item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      :class="
        'd-flex align-items-center ' +
        (item.g == 'resller' ? 'bg-light-success' : '')
      "
      @click="() => updateGroupOpen(!isOpen)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="tagText"
        pill
        :variant="liveKeys.length && tagText !== item.tag ? 'danger' : (item.tagVariant || 'primary')"
        :class="['mr-1 ml-auto', { 'nav-live-tag': liveKeys.length && tagText !== item.tag }]"
      >
        {{ tagText }}
      </b-badge>
    </b-link>
    <b-collapse v-model="isOpen" class="menu-content" tag="ul">
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from "bootstrap-vue";
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@core/layouts/utils";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useUtils as useAclUtils } from "@core/libs/acl";
import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";

// Composition Function
import useVerticalNavMenuGroup from "./useVerticalNavMenuGroup";
import mixinVerticalNavMenuGroup from "./mixinVerticalNavMenuGroup";
// a group shows the sum of its children's `liveTag` counts (pending parent requests), so it is seen while closed
import { reqCounts } from "@/libs/parent-requests";

export default {
  name: "VerticalNavMenuGroup",
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { live: reqCounts };
  },
  computed: {
    liveKeys() {
      var keys = [];
      if (this.item.liveTag) keys.push(this.item.liveTag);
      (this.item.children || []).forEach(function (c) {
        if (c.liveTag && keys.indexOf(c.liveTag) === -1) keys.push(c.liveTag);
      });
      return keys;
    },
    tagText() {
      if (!this.liveKeys.length) return this.item.tag;
      var live = this.live;
      var n = this.liveKeys.reduce(function (a, k) { return a + (live[k] > 0 ? live[k] : 0); }, 0);
      return n > 0 ? n : this.item.tag;
    },
  },
  setup(props) {
    const { isOpen, isActive, updateGroupOpen, updateIsActive } =
      useVerticalNavMenuGroup(props.item);

    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuGroup } = useAclUtils();

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    };
  },
};
</script>

<style>
</style>
